export default __webpack_public_path__ + "static/media/logo_nodonpro.43cd3533.png";